module.exports = __webpack_public_path__ + "static/media/bg-3.d9efe0a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/web/bg-3.png
// module id = 51
// module chunks = 3